import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import {
  Http
} from "@angular/http";
import "rxjs/add/operator/map";

@Injectable()
export class MasterService {
  constructor(private auth: AuthenticationService, private http: Http) { }

  //-- Unit

  GetUnit(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Unit",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  SaveUnit(Unit_Master: any) {
    if (Unit_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Unit",
          Unit_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/v1/Update_Unit",
          Unit_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteUnit(Id: number) {
    return this.http
      .delete(
        this.auth.baseUrl + "/services/api/v1/Delete_Unit?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // --- Unit

  // ---brand
  getBrand(Filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Brand",
        Filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveBrand(Brand_Master: any) {
    if (Brand_Master.Id == 0 || Brand_Master.Id == null) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Brand",
          Brand_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/v1/Update_Brand",
          Brand_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteBrand(Id: number) {
    return this.http
      .delete(
        this.auth.baseUrl + "/services/api/v1/Delete_Brand?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //---brand

  // --- Size
  getSize(FilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Size",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getSizeById(Id_ItemTypeId: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SizeById",
        Id_ItemTypeId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  saveSizeMaster(Size_Master: any) {
    if (Size_Master.Id == 0 || Size_Master.Id == null) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/save_Size",
          Size_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/v1/Update_Size",
          Size_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }

  deleteSizeMaster(Id: number) {
    return this.http
      .delete(
        this.auth.baseUrl + "/services/api/v1/Delete_Size?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // --- Size

  //---Colour
  getColour(FilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Colour",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveColour(Colour_Master: any) {
    if (Colour_Master.Id == 0 || Colour_Master.Id == null) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Colour",
          Colour_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/v1/Update_Colour",
          Colour_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteColourMaster(Id: number) {
    return this.http
      .delete(
        this.auth.baseUrl + "/services/api/v1/Delete_Colour?Id=" + Id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //---Colour
  //--------------VoucherType-----------------//

  //--------------VoucherType-----------------//
  //--------------Delivery Area----------------//
  Save_DeliveryArea(FilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Save_DeliveryArea",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_DeliveryArea(FilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryArea",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Delete_DeliveryArea(FilterData: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Delete_DeliveryArea",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Delivery Area----------------//
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/master.service.ts